import classnames from 'classnames';
import dynamic from 'next/dynamic';

import Button from 'molecules/Button';
import styles from 'molecules/FeaturedMedia/featured-media.module.scss';
import Icon from 'molecules/Icon';
import Image from 'molecules/Image';
import Lightbox from 'molecules/Lightbox';
import WistiaVideoPlayer from 'molecules/Video';

import type { FeaturedMediaProps } from 'molecules/FeaturedMedia/config';
import type { FC } from 'react';

const LoadableReactPlayer = dynamic(() => import('react-player/lazy'));

export interface MoleculeFeaturedMediaProps extends FeaturedMediaProps {
  classes?: Record<string, string>;
}

const FeaturedMedia: FC<MoleculeFeaturedMediaProps> = ({
  enableCallout,
  callout,
  classes,
  backgroundImage,
  backgroundMediaType,
  videoUrl,
}) => {
  const containerClass = classnames(styles.container, {
    [classes?.container || '']: classes?.container,
    [styles.calloutLeft]: callout?.calloutPosition === 'left',
    [styles.calloutRight]: callout?.calloutPosition === 'right',
    [styles.calloutTop]: callout?.calloutPosition === 'top',
    [styles.calloutBottom]: callout?.calloutPosition === 'bottom',
  });
  const hasCallout = enableCallout;
  const isCalloutVideo = callout?.isVideoPopup;

  const isBackgroundVideo = backgroundMediaType === 'video';

  return (
    <div className={containerClass}>
      {hasCallout && (
        <div
          className={classnames(styles.callout, {
            [styles.hasVideo]: isCalloutVideo,
          })}
        >
          {!isCalloutVideo && callout?.heading && <p className={styles.calloutLargeText}>{callout?.heading}</p>}
          {!isCalloutVideo && callout?.body && <p className={styles.calloutSmallText}>{callout?.body}</p>}
          {isCalloutVideo && callout?.embed && (
            <Lightbox classes={{ link: styles.videoLink }} modalContent={<WistiaVideoPlayer embed={callout?.embed} />}>
              <Icon icon="video" className={styles.videoIcon} />
              {callout?.videoPopupCopy}
            </Lightbox>
          )}
          {!isCalloutVideo && callout?.callToAction?.label && (
            <div className={styles.ctaLink}>
              <Button
                className={styles.arrowLink}
                direction="right"
                url={callout?.callToAction?.url}
                iconId="arrow-right"
              >
                {callout?.callToAction?.label}
              </Button>
            </div>
          )}
        </div>
      )}

      <div
        className={classnames(styles.mediaContainer, {
          [classes?.media || '']: classes?.media || '',
        })}
      >
        {isBackgroundVideo ? (
          <LoadableReactPlayer url={videoUrl} className={styles.video} height="100%" width="100%" playing loop muted />
        ) : (
          <Image
            url={backgroundImage?.url || ''}
            alt={backgroundImage?.alt || 'image-feature'}
            className={styles.mediaItem}
            width={backgroundImage?.width || 0}
            height={backgroundImage?.height || 0}
          />
        )}
      </div>
    </div>
  );
};

export default FeaturedMedia;
